import {css, html, LitElement} from "lit";
import {pxToRem} from "../styles";

export class MapMarker extends LitElement {
    public listingId: string;
    public longitude: number;
    public latitude: number;
    public label: string;
    public approximate: boolean;
    public showLabel: boolean;

    public constructor() {
        super();
        this.listingId = "";
        this.longitude = 0;
        this.latitude = 0;
        this.label = "";
        this.approximate = false;
        this.showLabel = false;
    }

    public static properties = {
        showLabel: {type: Boolean},
        label: {type: String},
        approximate: {type: Boolean},
    }

    public static styles = [
        css`
            :host {
                --inner-shadow: 0 0 0 5px var(--wl-map-point-approximate-shadow-color, green);
                --outer-shadow: 0 0 0 10px var(--wl-map-point-approximate-shadow-color, green);
            }
            .label {
                display: none;
                width: fit-content;
                color: white;
            }

            .show-price .label {
                display: block;
            }
            
            .outie-marker {
                align-items: center;
                display: flex;
                justify-content: center;
                cursor: pointer;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }

            .marker {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background-color: var(--wl-map-point-color, green);
                border: 2px solid white;

                display: block;
                cursor: pointer;
                padding: 0;
                font-size: 12px;
                box-shadow: 0 0 4px 0 #00000040;
            }

            .approximate {
                min-width: 10px;
                width: 10px;
                height: 10px;
                border-width: 5px;
                box-shadow: var(--inner-shadow),
                    var(--outer-shadow);
            }

            .show-price.outie-marker {
                width: fit-content;
            }
            
            .show-price .marker {
                border: 2px solid white;
                width: fit-content;
                height: 22px;
                border-radius: 15px;
                padding: 1px 12px;
                filter: drop-shadow(0px 0px 10px #b2b2b2);
            }
            
            .show-price .marker > span {
                display: inline-block;
                vertical-align: middle;
                line-height: normal;
            }

            .show-price .accurate::before {
                content: "";
                position: absolute;
                border: 5px solid;
                border-color: #fff transparent transparent;
                bottom: -10px;
                left: calc(50% - 5px);
            }
        `
    ];

    public render() {
        return html`<div class="outie-marker  ${this.showLabel ? "show-price" : ""}">
            <div class="marker ${this.approximate ? "approximate" : "accurate" }">
                <span class='label'>${this.label}</span>
            </div>
        <div>`
    }
}

export class MapClusterMarker extends LitElement {
    public total: number;

    constructor() {
        super();
        this.total = 0;
    }

    public static properties = {
        total: {type: Number},
    }

    public static styles = [
        css`
            :host {
                --shadow: 0 0 0 5px var(--wl-map-point-approximate-shadow-color, green);
            }
            
            .cluster {
                min-width: 24px;
                height: 24px;
                border-radius: 50%;
                color: white;
                font-weight: 700;
                text-align: center;
                border: 2px solid white;
                box-shadow: var(--shadow);
                cursor: pointer;
                padding: 0;
                background-color: var(--wl-map-point-color, white);
                
                font-size: ${pxToRem(12)};

                align-items: center;
                display: flex;
                justify-content: center;
            }
        `
    ]

    public render() {
        return html`<div class="cluster">
            <span>${this.total}</span>
        <div>`
    }
}


customElements.define("wl-map-marker", MapMarker);
customElements.define("wl-map-cluster-marker", MapClusterMarker);